import Small from 'UIComponents/elements/Small';
import UILink from 'UIComponents/link/UILink';
import AutomatedMessageContent from './AutomatedMessageContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AutomatedMessageSource({
  sourceLabel,
  sourceName,
  sourceUrl
}) {
  return /*#__PURE__*/_jsxs(AutomatedMessageContent, {
    children: [/*#__PURE__*/_jsx(Small, {
      children: sourceLabel
    }), /*#__PURE__*/_jsx(UILink, {
      href: sourceUrl,
      truncate: true,
      external: true,
      children: /*#__PURE__*/_jsx(Small, {
        children: sourceName || sourceUrl
      })
    })]
  });
}
AutomatedMessageSource.displayName = 'AutomatedMessageSource';